import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup, styled, useTheme } from "@mui/material"
import { useState } from "react";

const CustomRadio = styled(Radio)(({ theme }) => ({
  '&.Mui-checked': {
    color: theme.palette.white.main,
  },
  '&.Mui-checked .MuiSvgIcon-root': {
    backgroundColor: theme.palette.ethicsBlue.main,
  },
  '.MuiSvgIcon-root': {
    fontSize: 16,
    borderRadius: '50%',
  },
}));

export const Radios = ({ 
  text,
  value,
  onChangue,
  options = [],
  size = 'small',
  sxLabel = {},
  sxOption = {},
  required = false,
  isValid = null,
  showSuccessValidation,
  ...rest
}) => {
  const theme = useTheme();
  const [helperText, setHelperText] = useState('');

  const returnColor = (focused) => {
    if (isValid === false) return "error.main";
    if (isValid === true && showSuccessValidation) return "success.main";
    return "secondary.main";
  }

  return (
    <FormControl>
      <FormLabel sx={{
        "&": {
          fontSize: 13,
          fontWeight: 600,
          color: returnColor(),
          ...sxLabel
        },
        "&.Mui-focused": {
          color: returnColor(true),
        },
      }} >
        {text}{required && " *"}
      </FormLabel>
      <RadioGroup
        value={value}
        onChange={(e, val)=>onChangue(val)}
        {...rest}
      >
        {
          options.map(opt=>(
            <FormControlLabel
              key={opt.value}
              value={opt.value} 
              label={opt.label} 
              control={<CustomRadio />} 
              sx={{
                '& .MuiTypography-root': {
                  fontWeight: 600,
                  color: 'secondary.main',
                },
                ...sxOption
              }}
            />
          ))
        }
      </RadioGroup>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  )
}
